module.exports = __webpack_public_path__ + "media/images/ultra-e9f2826261e3eff349299b0be88fb0dc.svg";